<template>
  <STIRRecruitment />
</template>

<script>
/* eslint-disable */
import STIRRecruitment from '@/components/PageHome.vue';

export default {
  name: 'HomeVue',
  components: {
    STIRRecruitment
  }
};
</script>
